import {
  isSocialLinkingPlatform,
  type SocialLinkingPlatform,
} from './visibleSocialLinkingPlatforms';

export type AccountSettingsSocialPlatform = SocialLinkingPlatform;

export interface AccountSettingsEventTarget {
  focusSocialPlatform: AccountSettingsSocialPlatform | null;
}

function ownDataValue(value: object, key: PropertyKey): unknown {
  try {
    const descriptor = Object.getOwnPropertyDescriptor(value, key);
    return descriptor && Object.prototype.hasOwnProperty.call(descriptor, 'value')
      ? descriptor.value
      : undefined;
  } catch {
    return undefined;
  }
}

function isSocialPlatform(value: unknown): value is AccountSettingsSocialPlatform {
  return isSocialLinkingPlatform(value);
}

/** Accepts only the small public navigation contract used by publishing and
 * analytics. Unknown objects, accessors, and hostile proxies do not open or
 * influence Account Settings. A detail-less event preserves the legacy
 * behavior of opening the default settings view. */
export function parseOpenAccountSettingsDetail(detail: unknown): AccountSettingsEventTarget | null {
  if (detail == null) return { focusSocialPlatform: null };
  if (typeof detail !== 'object') return null;
  try {
    if (Array.isArray(detail)) return null;
  } catch {
    return null;
  }

  const section = ownDataValue(detail, 'section');
  const platform = ownDataValue(detail, 'platform');
  if (section !== 'social') return null;
  if (platform === undefined) return { focusSocialPlatform: null };
  if (!isSocialPlatform(platform)) return null;
  return { focusSocialPlatform: platform };
}
